import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Dropzone from 'dropzone';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor(private toastr: ToastrService, private http: HttpClient) { }

  uploadImage(event: Event, url: string): Observable<any> {

    if (!event.target) return of(null);
    if (!(event.target as HTMLInputElement).files) return of(null);

    const file = (event.target as HTMLInputElement).files![0];

    if (!file) return of(null);

    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
      this.toastr.error(
        `invalid image type`,
        'Success'
      );

      return of(null);
    }

    if (file.size > 5242880) {
      this.toastr.error(
        `invalid image size\nsize must be less than 5mb`,
        'Success'
      );

      return of(null);
    }

    const formData = new FormData();
    formData.append('File', file);

    return this.http.post(url, formData);
  }

  initDropzone(id: HTMLElement, url: string) {

    return new Dropzone(id, {
      url,
      headers: { "Authorization": "Bearer " + sessionStorage.getItem('accessToken') },
      paramName: "File",
      maxFiles: 1,
      maxFilesize: 10,
      addRemoveLinks: true,
      acceptedFiles: 'image/*',
      error: (file, error: any, xhr) => {
        this.toastr.error(
          error.message ?? '',
          'Error uploading the image'
        );
      }
    });
  }
}
